import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

import { TUTORIAL_MASK_WRAPPER_ZINDEX } from '../../hooks/tutorial/useTutorialStyles';
import { useTutorialUtilities } from '../../hooks/tutorial/useTutorialUtilities';

export const TutorialBackdropLayer = () => {
	const { $t } = useIntl();

	const {
		isOpen,
		tutorial: { preventBeginnerText }
	} = useTutorialUtilities();

	if (!isOpen || preventBeginnerText) return null;

	return (
		<S.Wrapper>
			<S.Container>
				<S.BottomContent>
					<S.Label>{$t('global.tutorialLabel')}</S.Label>
				</S.BottomContent>
			</S.Container>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: ${TUTORIAL_MASK_WRAPPER_ZINDEX + 1};
	`;

	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		height: 100%;
		width: auto;
		margin: 0 auto;
		justify-content: flex-end;
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			width: 100%;
		}
	`;

	export const BottomContent = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		margin-left: ${({ theme }) => theme.spacings.small};
		margin-bottom: ${({ theme }) => theme.spacings.large};
		align-items: center;
		${({ theme }) => theme.breakpoints.queries.below.mobile} {
			margin-bottom: ${({ theme }) => theme.spacings.small};
		}
	`;

	export const Label = styled.span`
		${({ theme }) => theme.fonts.text.caption2};
		color: ${({ theme }) => theme.colors.white};
	`;
}
